import type { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import ErrorRec from 'app/icons/error_rectangle.svg';

import style from './style.module.scss';

const FloatingRectangles: FC<ClassNameProp & PropsWithChildren> = ({ children, className }) => (
  <div className={classNames(style.floatingRectanglesContainer, className)}>
    <ErrorRec className={style.rectangle1} />
    <ErrorRec className={style.rectangle2} />
    <ErrorRec className={style.rectangle3} />
    <div className={style.messageContainer}>{children}</div>
    <ErrorRec className={style.rectangle4} />
    <ErrorRec className={style.rectangle5} />
    <ErrorRec className={style.rectangle6} />
  </div>
);

FloatingRectangles.displayName = 'FloatingRectangles';

export default FloatingRectangles;
